import React from 'react';
import './BudgetTracker.css';

function BudgetTracker({ selectedRiders, riders, totalBudget, headerMode = false, swapDemand = 0 }) {
  const spentBudget = selectedRiders.reduce((sum, rider) => {
    const riderInfo = riders[rider];
    const price = typeof riderInfo === 'object' ? riderInfo.price : riderInfo;
    return sum + (price || 500000);
  }, 0);

  const totalSpentDisplay = spentBudget + swapDemand;

  // Check if budget will be exceeded
  // If we have > 20 riders: check total of all selected riders
  // If we have <= 20 riders: check total spent + cost to fill remaining slots with minimum price
  let minPossibleTotal;
  if (selectedRiders.length > 20) {
    minPossibleTotal = spentBudget + swapDemand; // Use all selected riders
  } else {
    minPossibleTotal = spentBudget + Math.max(0, 20 - selectedRiders.length) * 500000 + swapDemand; // Add cost of remaining slots
  }

  const isOverBudget = minPossibleTotal > totalBudget;

  if (headerMode) {
    // Compact mode for header - no box, just counters
    return (
      <div className={`budget-tracker header-compact ${isOverBudget ? 'over-budget' : ''}`}>
        <div className="counters-row">
          <div className="counter-item">
            <span className="counter-label">Renners</span>
            <div className="top-values">
              <span className={`header-rider-count ${selectedRiders.length > 20 ? 'over' : ''}`}>{selectedRiders.length}</span>
              <span className="separator">/</span>
              <span className="total">20</span>
            </div>
          </div>
          <div className="counter-item">
            <span className="counter-label">Budget</span>
            <div className="top-values">
              <span className={`header-spent ${isOverBudget ? 'over' : ''}`}>€ {(totalSpentDisplay / 1000000).toFixed(2)}M</span>
              <span className="separator">/</span>
              <span className="total">€ {(totalBudget / 1000000).toFixed(2)}M</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`budget-tracker ${isOverBudget ? 'over-budget' : ''}`}>
      <div className="top-bar">
        <div className="counters-row">
          <div className="counter-item">
            <div className="top-values">
              <span className={`rider-count ${selectedRiders.length > 20 ? 'over' : ''}`}>{selectedRiders.length}</span>
              <span className="separator">/</span>
              <span className="total">20</span>
            </div>
          </div>
          <div className="counter-item">
            <div className="top-values">
              <span className={`bottom-spent ${isOverBudget ? 'over' : ''}`}>€ {(totalSpentDisplay / 1000000).toFixed(2)}M</span>
              <span className="separator">/</span>
              <span className="total">€ {(totalBudget / 1000000).toFixed(2)}M</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BudgetTracker;
